// Auto-detect API URL based on environment
const getApiUrl = () => {
  // Use environment variable if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // In production, use same-origin API proxy
  if (typeof window !== 'undefined') {
    // app.mycastle.gg subdomain
    if (window.location.hostname === 'app.mycastle.gg') {
      return 'https://app.mycastle.gg/api';
    }
    // mycastle.gg main domain
    if (window.location.hostname === 'mycastle.gg' || window.location.hostname === 'www.mycastle.gg') {
      return 'https://mycastle.gg/api';
    }
  }

  // Default for local development
  return 'http://localhost:8000';
};

const config = {
  API_URL: getApiUrl()
};

export default config;